import { render, staticRenderFns } from "./F12.vue?vue&type=template&id=5cc9ad1a&scoped=true"
import script from "./F12.vue?vue&type=script&lang=js"
export * from "./F12.vue?vue&type=script&lang=js"
import style0 from "./F12.vue?vue&type=style&index=0&id=5cc9ad1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc9ad1a",
  null
  
)

export default component.exports